import { Link } from 'react-router-dom'

export function Footer() {
  return (
    <footer className="footer">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="grid grid-cols-1 gap-8">
          {/* About */}
          <div>
            <h3 className="font-semibold mb-4 text-white">AgentTeamForge Studio</h3>
            <p className="text-sm text-light">
              Plateforme de création et de gestion d'agents conversationnels intelligents.
            </p>
          </div>

          {/* Legal Links */}
          <div>
            <h3 className="font-semibold mb-4 text-white">Informations légales</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link
                  to="/legal/mentions"
                  className="action-link text-light"
                >
                  Mentions légales
                </Link>
              </li>
              <li>
                <Link
                  to="/legal/privacy"
                  className="action-link text-light"
                >
                  Politique de confidentialité
                </Link>
              </li>
              <li>
                <Link
                  to="/legal/terms"
                  className="action-link text-light"
                >
                  Conditions d'utilisation
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold mb-4 text-white">Contact</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link
                  to="/contact"
                  className="action-link text-light"
                >
                  Formulaire de contact
                </Link>
              </li>
              <li>
                <a
                  href="mailto:support@therapia.solutions"
                  className="action-link text-light"
                >
                  support@therapia.solutions
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-8 text-center text-sm footer-section text-light">
          <p>&copy; {new Date().getFullYear()} AgentTeamForge. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  )
}

